/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Esito della vista tariffa mensa del cittadino
 */
export enum StatoTariffaCittadino {

    OK = 'OK',

    TARIFFA_ASSENTE = 'TARIFFA_ASSENTE',

    NESSUNA_REGOLA = 'NESSUNA_REGOLA',

    STUDENTE_SOSPESO = 'STUDENTE_SOSPESO'
}

